import Vue from 'vue'
import axios from 'axios'
import router from '@/router'
import qs from 'qs'
import * as Sentry from '@sentry/browser'

const instance = axios.create({
  baseURL: `${process.env.VUE_APP_CORE_URL}/api`
})
instance.defaults.paramsSerializer = params => {
  return qs.stringify(params, { arrayFormat: 'repeat' })
}
instance.interceptors.request.use(
  reqConfig => {
    if (Vue.prototype.$getCookie('comLoginToken')) {
      const xCorrelationId = Vue.prototype.$getGuid()
      reqConfig.headers = {
        KingnetAuth: 'Cookies ' + Vue.prototype.$getCookie('comLoginToken').split('token=').pop(),
        'X-Correlation-Id': xCorrelationId
      }
      Sentry.setTag('X-Correlation-Id', xCorrelationId)
      return reqConfig
    } else {
      Vue.prototype.$alert('登入過期或驗證失敗，請重新登入', '警告', {
        confirmButtonText: '確定',
        type: 'warning',
        showClose: false,
        roundButton: true,
        closeOnClickModal: false
      }).then(() => {
        router.push({ name: 'LoginMain' })
      })
    }
  },
  err => {
    return Promise.reject(err)
  }
)
instance.interceptors.response.use(
  res => res,
  err => {
    // eslint-disable-next-line eqeqeq
    if (err && err.response && (err.response.status == 401 || err.response.status == 403) && document.getElementsByClassName('v-modal').length == 0) {
      if (err.response.data.Message !== undefined) {
        Vue.prototype.$alert(`${err.response.data.Message}`, '警告', {
          confirmButtonText: '確定',
          type: 'warning',
          showClose: false,
          roundButton: true,
          closeOnClickModal: false
        }).then(() => {
          // eslint-disable-next-line eqeqeq
          if (err.response.status == 401) { router.push({ name: 'LoginMain' }) } else if (err.response.status == 403) { Vue.prototype.$toMainPage() }
        })
        return Promise.reject(err)
      }
    } else if (err && err.response && err.response.status === 409) {
      Vue.prototype.$alert(err.response.data.ErrorMessage.Description, '警告', {
        confirmButtonText: '確定',
        type: 'warning',
        showClose: false,
        roundButton: true,
        closeOnClickModal: false
      }).then(() => {
        // eslint-disable-next-line eqeqeq
        if (err.response.status == 404) { router.push({ name: 'LoginMain' }) }
      })
      return Promise.reject(err)
    } else {
      return Promise.reject(err)
    }
  }
)

// Swagger: https://local.kingnetsmart.com.tw/core/index.html#/ManagerClock
export const apiAttendanceManagement = {
  GetCommunityClockAuth: (config) => instance.get('/Community/CrossCommunityClock', config), // 取得社區權限與各項設定
  // 上班
  ClockIn: {
    PostClockCardValidation: (requestData, config) => instance.post('/ManagerClock/ClockIn/Validation', requestData, config), // 判斷上班載具是否合法
    PostClockIn: (requestData, config) => instance.post('/ManagerClock/ClockIn', requestData, config), // 合法載具，上班打卡
    PostNotInCompanyClockIn: (requestData, config) => instance.post('/ManagerClock/ClockIn/NotInCompany', requestData, config), // 有實名制帳號的載具，但未在合法企業雲
    PostOneTimeClockIn: (requestData, config) => instance.post('/ManagerClock/ClockIn/OneTime', requestData, config), // 一次性上班打卡
    GetCompanyJobTitleAndShiftClass: (config) => instance.get('/ManagerClock/CompanyJobTitleAndShiftClass', config) // 取得差勤紀錄列表
  },
  // 下班
  ClockOut: {
    GetNoClockOutList: (config) => instance.get('/ManagerClock/NoClockOut', config), // 取得24小時內，未下班列表
    PostClockOut: (queryPath, requestData, config) => instance.post(`/ManagerClock/${queryPath.ClockId}/ClockOut`, requestData, config), // 下班打卡
    PostOneTimeClockOut: (queryPath, requestData, config) => instance.post(`/ManagerClock/${queryPath.ClockId}/ClockOut/OneTime`, requestData, config) // 一次性下班打卡
  },
  // 差勤紀錄
  Record: {
    GetClockList: (requestData, config) => instance.get('/ManagerClock', Object.assign({}, { params: requestData }, config)), // 取得差勤紀錄列表
    GetClockListExcel: (requestData, config) => instance.get('/ManagerClock/Excel', Object.assign({}, { params: requestData }, config)), // 取得差勤紀錄列表Excel
    PutListRemark: (queryPath, requestData, config) => instance.put(`/ManagerClock/${queryPath.ClockId}`, requestData, config) // 更新列表（上班與下班）備註
  }
}
